import React from "react";
import { BrowserRouter, Switch, Route as RouterRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import GxonLayout from "../components/GxonTemplate/GxonLayout";
import DashboardGxonTemplate from "../pages/Dashboard/DashboardGxonTemplate";
import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import DashboardPerformance from "../pages/DashboardPerformance/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/LoginGxon";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Schedules from "../pages/Schedules/";
import ContactSchedules from "../pages/ContactSchedules/";
import Chatbot from "../pages/Chatbot/";
import Tags from "../pages/Tags/";
import Specialties from "../pages/Specialties/";
import SubSpecialties from "../pages/SubSpecialties/";
import Professionals from "../pages/Professionals/";
import Appointments from "../pages/Appointments/";
import Holidays from "../pages/Holidays/";
import CampaignLandingPages from "../pages/CampaignLandingPages/";
import CampaignLeads from "../pages/CampaignLeads/";
import MarketingDashboard from "../pages/MarketingDashboard/";
import Campaigns from "../pages/Campaigns/";
import WhatsAppStatus from "../pages/WhatsAppStatus/";
import Products from "../pages/Products/";
import Kanban from "../pages/Kanban/";
import KanbanBoard from "../pages/KanbanBoard/";
import KanbanReports from "../pages/KanbanReports/";
import PublicLandingPage from "../pages/PublicLandingPage/";
import PublicQuizPage from "../pages/PublicQuizPage/";
import PublicPwaPage from "../pages/PublicPwaPage/";
import WhatsAppQRCode from "../pages/WhatsAppQRCode/";
import WordPressIntegration from "../pages/Integrations/WordPress";
import DzapyChatIntegration from "../pages/Integrations/DzapyChat";
import ApiDzapy from "../pages/Integrations/ApiDzapy";
import SmtpConfigs from "../pages/SmtpConfigs/";
import Emails from "../pages/Emails/";
import EmailRead from "../pages/EmailRead/";
import EmailCompose from "../pages/EmailCompose/";
import EmailTemplates from "../pages/EmailTemplates/";
import EmailCampaigns from "../pages/EmailCampaigns/";
import EmailCampaignWizard from "../pages/EmailCampaignsWizard/";
import EmailCampaignDetails from "../pages/EmailCampaignDetails/";
import Orders from "../pages/Orders/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Switch>
          <RouterRoute exact path="/lp/:slug" component={PublicLandingPage} />
          <RouterRoute exact path="/lp/:slug/quiz" component={PublicQuizPage} />
          {/* <RouterRoute exact path="/pwa" component={PublicPwaPage} /> */}
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={Signup} />

          <WhatsAppsProvider>
            <Route isPrivate>
              <GxonLayout>
                <Switch>
                  <RouterRoute exact path="/" component={DashboardGxonTemplate} />
                  <RouterRoute exact path="/dashboard-old" component={Dashboard} />
                  <RouterRoute exact path="/dashboard-performance" component={DashboardPerformance} />
                  <RouterRoute exact path="/tickets/:ticketId?" component={Tickets} />
                  <RouterRoute exact path="/connections" component={Connections} />
                  <RouterRoute exact path="/contacts" component={Contacts} />
                  <RouterRoute exact path="/users" component={Users} />
                  <RouterRoute exact path="/quickAnswers" component={QuickAnswers} />
                  <RouterRoute exact path="/chatbot" component={Chatbot} />
                  <RouterRoute exact path="/Settings" component={Settings} />
                  <RouterRoute exact path="/Queues" component={Queues} />
                  <RouterRoute exact path="/schedules" component={Schedules} />
                  <RouterRoute exact path="/contact-schedules" component={ContactSchedules} />
                  <RouterRoute exact path="/tags" component={Tags} />
                  <RouterRoute exact path="/specialties" component={Specialties} />
                  <RouterRoute exact path="/subspecialties" component={SubSpecialties} />
                  <RouterRoute exact path="/professionals" component={Professionals} />
                  <RouterRoute exact path="/appointments" component={Appointments} />
                  <RouterRoute exact path="/holidays" component={Holidays} />
                  <RouterRoute exact path="/campaign-landing-pages" component={CampaignLandingPages} />
                  <RouterRoute exact path="/campaign-leads" component={CampaignLeads} />
                  <RouterRoute exact path="/marketing-dashboard" component={MarketingDashboard} />
                  <RouterRoute exact path="/campaigns" component={Campaigns} />
                  <RouterRoute exact path="/whatsapp-status" component={WhatsAppStatus} />
                  <RouterRoute exact path="/products" component={Products} />
                  <RouterRoute exact path="/whatsapp-qrcode" component={WhatsAppQRCode} />
                  <RouterRoute exact path="/kanban" component={Kanban} />
                  <RouterRoute exact path="/kanban/board" component={KanbanBoard} />
                  <RouterRoute exact path="/kanban/reports" component={KanbanReports} />
                  <RouterRoute exact path="/integrations/wordpress" component={WordPressIntegration} />
                  <RouterRoute exact path="/integrations/dzapy-chat" component={DzapyChatIntegration} />
                  <RouterRoute exact path="/integrations/api-dzapy" component={ApiDzapy} />
                  <RouterRoute exact path="/smtp-configs" component={SmtpConfigs} />
                  <RouterRoute exact path="/emails" component={Emails} />
                  <RouterRoute exact path="/emails/compose" component={EmailCompose} />
                  <RouterRoute exact path="/emails/:smtpConfigId/:folder/:uid" component={EmailRead} />
                  <RouterRoute exact path="/email-templates" component={EmailTemplates} />
                  <RouterRoute exact path="/email-campaigns" component={EmailCampaigns} />
                  <RouterRoute exact path="/email-campaigns/new" component={EmailCampaignWizard} />
                  <RouterRoute exact path="/email-campaigns/:campaignId/details" component={EmailCampaignDetails} />
                  <RouterRoute exact path="/email-campaigns/:campaignId" component={EmailCampaignWizard} />
                  <RouterRoute exact path="/orders" component={Orders} />
                </Switch>
              </GxonLayout>
            </Route>
          </WhatsAppsProvider>
        </Switch>
        <ToastContainer autoClose={3000} />
      </AuthProvider>
    </BrowserRouter >
  );
};

export default Routes;
